@if (hardwareSetSelect) {
  <icc-select-box
    [title]="'DOOR|Zestaw osprzętu' | translate"
    [description]="hardwareSetSelect.name"
    [imageUrl]="'/files/hardwareset/' + (hardwareSetSelect?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeHardwareSet()"
    [descriptionTemplate]="hardwareSetBoxTemplate"
    [descriptionContext]="hardwareSetSelect"
    [disabledButton1]="isChangeHardwareSetDisabled()"
  ></icc-select-box>
}

@if ((lock$ | async)) {
  <icc-select-box
    [title]="'DOOR|Zamek' | translate"
    [description]="(lock$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((lock$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeLock()"
    [descriptionTemplate]="locksBoxTemplate"
    [descriptionContext]="lockBoxSelect"
    [disabledButton1]="isLockButtonDisabled()"
  ></icc-select-box>
}
@if ((showWindowLeverBox$ | async) && (showDoorHandleAdjustmentBox$ | async)) {
  <icc-select-box
    [title]="'DOOR|Przystosowanie pod pochwyt' | translate"
    [description]="(doorHandleAdjustment$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((doorHandleAdjustment$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isDoorHandleAdjustmentDisabled()"
    (select)="changeDoorHandleAdjustment()"
  ></icc-select-box>
}
@if (showWindowLeverBox$ | async) {
  <icc-select-box
    [title]="'DOOR|Typ osprzętu' | translate"
    [description]="(selectedHardwareType$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((selectedHardwareType$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isHardwareTypeDisabled()"
    [buttonText2]="(selectedHardwareType$ | async)?.id && ('INTERFACE|Opcje' | translate)"
    (select)="selectType()"
    (select2)="changeTypeOptions()"
    [descriptionTemplate]="typeBoxTemplate"
    [descriptionContext]="hardwareTypeBoxSelect"
  ></icc-select-box>
}
@if ((pull$ | async) && ((hardwareSet$ | async) === 'leverPull' && ((doorHandleAdjustment$ | async)?.id && (showWindowLeverBox$ | async) || !(showWindowLeverBox$ | async))) || (hardwareSet$ | async) === 'doublePull') {
  <icc-select-box
    [title]="'DOOR|Pochwyt' | translate"
    [imageUrl]="pullBoxSelect.pullType.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="isPullColorRelatedToPlate !== true ? ('INTERFACE|Opcje' | translate) : false"
    (select)="changePull()"
    (select2)="openPullsOptions()"
    [descriptionTemplate]="pullBoxTemplate"
    [descriptionContext]="pullBoxSelect"
    [disabledButton1]="isPullButtonDisabled()"
    [disabledButton2]="isPullButton2Disabled()"
  ></icc-select-box>
}
@if ((fillingWithRecessedPull$ | async) && (hardwareSet$ | async) === 'leverRecessedPull') {
  <icc-select-box
    [title]="'DOOR|Pochwyt kieszeniowy' | translate"
    [imageUrl]="recessedPullBoxSelect.pullType.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="isRecessedPullColorsAvailable === true ? ('INTERFACE|Opcje' | translate) : false"
    (select)="changeRecessedPull()"
    (select2)="openRecessedPullOptions()"
    [descriptionTemplate]="recessedPullBoxTemplate"
    [descriptionContext]="recessedPullBoxSelect"
    [disabledButton1]="isRecessedPullButtonDisabled()"
    [disabledButton2]="isRecessedPullButton2Disabled()"
  ></icc-select-box>
}
@if (integratedPull) {
  <icc-select-box
    [title]="'DOOR|Pochwyt' | translate"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    [descriptionTemplate]="integratedPullBoxTemplate"
    [disabledButton1]="true"
    [disabledButton2]="true"
    [minHeight]="true"
  ></icc-select-box>
}
@if ((selectedHardwareType$ | async)?.electronic_door_lock) {
  <icc-select-box
    [title]="'DOOR|Typ elektronicznej wkładki' | translate"
    [description]="(electronicLock$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((electronicLock$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isElectronicLockDisabled()"
    (select)="changeElectronicLock()"
  ></icc-select-box>
}
@if ((showWindowLeverBox$ | async) && (selectedHardwareType$ | async)?.id) {
  <icc-select-box
    [title]="'DOOR|Typ oszyldowania' | translate"
    [description]="(plateType$ | async)?.name"
    [imageUrl]="'/files/windowaccessory/' + ((plateType$ | async)?.img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isPlateTypeDisabled()"
    (select)="changePlateType()"
  ></icc-select-box>
}
@if ( ((plateMainLock$ | async) || (plateAdditionalLock$ | async)) && !(showWindowLeverBox$ | async) && (hardwareSet$ | async) && ((hardwareSet$ | async) !== 'mixedLever')) {
  <icc-select-box
    [title]="'DOOR|Szyldy' | translate"
    [imageUrl]="(plateMainLockBoxSelect$ | async)?.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="openPlatesOptions()"
    (select2)="changePlateToMainLockOptions()"
    [descriptionTemplate]="platesBoxTemplate"
    [descriptionContext]="platesBoxSelect"
    [disabledButton1]="isPlatesButtonDisabled()"
    [disabledButton2]="isPlatesToMainLockButton2Disabled()"
  ></icc-select-box>
}

@if ( ((innerPlateMainLock$ | async) || (innerPlateAdditionalLock$ | async)) && !(showWindowLeverBox$ | async) && (hardwareSet$ | async) && ((hardwareSet$ | async) === 'mixedLever')) {
  <icc-select-box
    [title]="'DOOR|Szyld wewnętrzny' | translate"
    [imageUrl]="(plateMainLockBoxSelect$ | async)?.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="openPlatesOptions()"
    (select2)="changePlateToMainLockOptions()"
    [descriptionTemplate]="platesBoxTemplateMixedLever"
    [descriptionContext]="platesBoxSelect"
    [disabledButton1]="isPlatesButtonDisabled()"
    [disabledButton2]="isPlatesToMainLockButton2Disabled()"
  ></icc-select-box>
}

@if ( ((outerPlateMainLock$ | async) || (outerPlateAdditionalLock$ | async)) && !(showWindowLeverBox$ | async) && (hardwareSet$ | async) && ((hardwareSet$ | async) === 'mixedLever')) {
  <icc-select-box
    [title]="'DOOR|Szyld zewnętrzny' | translate"
    [imageUrl]="(outerPlateMainLockBoxSelect$ | async)?.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="openPlatesOptions('outer')"
    (select2)="changePlateToMainLockOptions('outer')"
    [descriptionTemplate]="platesBoxTemplateMixedLever"
    [descriptionContext]="outerPlatesBoxSelect"
    [disabledButton1]="isPlatesButtonDisabled('outer')"
    [disabledButton2]="isPlatesToMainLockButton2Disabled('outer')"
  ></icc-select-box>
}
@if (!(showWindowLeverBox$ | async) && (hardwareSet$ | async) && isCylinderBoxVisible()) {
  <icc-select-box
    [title]="'DOOR|Wkładki' | translate"
    [imageUrl]="(cylindersBoxSelect?.cylinders.imagePath || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="((isKeyAvailableForMainLock || cylindersBoxSelect?.cylinders?.color) && 'INTERFACE|Opcje' | translate)"
    (select)="openCylindersOptions()"
    (select2)="changeCylinderToMainLockOptions()"
    [descriptionTemplate]="cylindersBoxTemplate"
    [descriptionContext]="cylindersBoxSelect"
    [disabledButton1]="isCylinderMainLockButtonDisabled()"
    [disabledButton2]="isCylinderMainLockButton2Disabled()"
  ></icc-select-box>
}
@if ((showDoorViewer$ | async)) {
  <icc-select-box
    [title]="'DOOR|Wizjer' | translate"
    [description]="(doorViewer$ | async)?.name"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    [imageUrl]="getDoorViewerImageUrl()"
    (select)="changeDoorViewer()"
    (select2)="changeDoorViewerOptions()"
    [descriptionTemplate]="doorViewerBoxTemplate"
    [descriptionContext]="doorViewerBoxSelect"
    [disabledButton1]="isDoorViewerButtonDisabled()"
    [disabledButton2]="isDoorViewerButton2Disabled()"
  ></icc-select-box>
}

@if ((contextInfoInDoorViewer$ | async)) {
  <mat-card  appearance="outlined" >
    <mat-card-content>
      <p>
        {{(contextInfoInDoorViewer$ | async)}}
      </p>
    </mat-card-content>
  </mat-card>
}

@if (!(showWindowLeverBox$ | async) && (doorViewer$ | async)?.id && (showDoorViewerPunchingOption$ | async)) {
  <mat-slide-toggle
    (change)="changeDoorViewerPunching($event)"
    [checked]="doorViewerPunching$ | async"
    >
    {{ 'DOOR|Otworowanie pod wizjer' | translate }}
  </mat-slide-toggle>
}

@if ((hinge$ | async)) {
  <icc-select-box
    [title]="'DOOR|Zawiasy' | translate"
    [description]="(hinge$ | async)?.name"
    [imageUrl]="(hingeBoxSelect$ | async)?.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeHinges()"
    [disabledButton1]="isHingeButtonDisabled()"
  ></icc-select-box>
}
@if (((showDecorativeHingeCovers$ | async) && (decorativeHingeCoversColor$ | async))) {
  <icc-select-box
    [title]="'DOOR|Ozdobne nakładki zawiasów' | translate"
    [description]="(decorativeHingeCoversColor$ | async)?.name"
    [color]="'#' + (decorativeHingeCoversColor$ | async)?.color"
    [imageUrl]="'/files/windowhandlescolor/' + ((decorativeHingeCoversColor$ | async)?.color_img || '')"
    [buttonText]="'INTERFACE|Zmień' | translate"
    (select)="changeDecorativeHingeCover()"
    [colorSelect]="true"
    [disabledButton1]="isDecorativeHingeCoverButtonDisabled()"
  ></icc-select-box>
}

<ng-template #typeBoxTemplate let-name="name" let-color="color" let-description="description">
  <p> <b>{{ 'DOOR|Typ osprzętu:' | translate }}</b> {{name || ('INTERFACE|Brak' | translate)}}</p>
  @if (color) {
    <p>
      <b>{{ 'DOOR|Kolor:' | translate }}</b> {{color}}
    </p>
  }
  <p ng-bind-html="description"></p>
</ng-template>


<ng-template #platesBoxTemplate let-mainLockName="mainLockName" let-additionalLockName="additionalLockName" let-color="color" let-description="description">
  @if (mainLockName) {
    <p> <b>{{ 'DOOR|Typ szyldu zamka głównego' | translate }}</b> {{mainLockName}}</p>
  }
  @if (additionalLockName) {
    <p> <b>{{ 'DOOR|Typ szyldu zamka dodatkowego' | translate }}</b> {{additionalLockName}}</p>
  }
  @if (color) {
    <p>
      <b>{{ 'DOOR|Kolor:' | translate }}</b> {{color}}
    </p>
  }
  <p ng-bind-html="description"></p>
</ng-template>

<ng-template #platesBoxTemplateMixedLever let-mainLockName="mainLockName" let-additionalLockName="additionalLockName" let-color="color" let-description="description">
  @if (mainLockName) {
    <p> <b>{{ 'DOOR|Model szyldu zamka głównego' | translate }}</b> {{mainLockName}}</p>
  }
  @if (additionalLockName) {
    <p> <b>{{ 'DOOR|Model szyldu zamka dodatkowego' | translate }}</b> {{additionalLockName}}</p>
  }
  @if (color) {
    <p>
      <b>{{ 'DOOR|Kolor:' | translate }}</b> {{color}}
    </p>
  }
  <p ng-bind-html="description"></p>
</ng-template>

<ng-template #cylindersBoxTemplate let-cylinders="cylinders">
  @if (cylinders?.mainLockName) {
    <p> <b>{{ 'DOOR|Rodzaj wkładki zamka głównego' | translate }}</b> {{cylinders.mainLockName}}</p>
  }
  @if (cylinders?.mainLockColor) {
    <p>
        <b>{{ 'COLOR|Kolor:' | translate }}</b> {{cylinders?.mainLockColor}}
    </p>
  }
  @if (cylinders?.additionalLockName) {
    <p> <b>{{ 'DOOR|Rodzaj wkładki zamka dodatkowego' | translate }}</b> {{cylinders.additionalLockName}}</p>
  }
  @if (cylinders?.additionalLockColor) {
    <p>
        <b>{{ 'COLOR|Kolor:' | translate }}</b> {{cylinders?.additionalLockColor}}
    </p>
  }

  <!--
  /*
  Hidden until client describes how the cylinder system is supposed to work.
  */
  <p *ngIf="cylinders?.system"> <b>{{ 'DOOR|System wkładek' | translate }}</b> {{cylinders.system}}</p>-->
  @if (electronicLockBoxSelect?.electronicLockName) {
    <p>
      <b>{{ 'DOOR|Typ elektronicznej wkładki'   | translate }}</b> {{ electronicLockBoxSelect.electronicLockName }}
    </p>
  }
  @if (electronicLockBoxSelect?.electronicLockColor) {
    <p>
      <b> {{ 'DOOR|Kolor' | translate}} </b> {{ electronicLockBoxSelect.electronicLockColor }}
    </p>
  }
  <p ng-bind-html="description"></p>
</ng-template>

<ng-template #pullBoxTemplate let-pull="pullType" let-color="color">
  <p> <b>{{ 'DOOR|Typ pochwytu' | translate }}</b> {{ pullBoxSelect.pullType?.name }} </p>
  @if (pullBoxSelect.pullType?.color) {
    <p> <b>{{ 'DOOR|Kolor:' | translate }}</b> {{ pullBoxSelect.pullType?.color}} </p>
  }
</ng-template>

<ng-template #recessedPullBoxTemplate let-pull="pullType" let-color="color">
  <p> <b>{{ 'DOOR|Typ pochwytu' | translate }}</b> {{ recessedPullBoxSelect.pullType?.name }} </p>
  @if (recessedPullBoxSelect.pullType?.color) {
    <p> <b>{{ 'DOOR|Kolor:' | translate }}</b> {{ recessedPullBoxSelect.pullType?.color}} </p>
  }
</ng-template>
<ng-template #integratedPullBoxTemplate>
  <p> <b>{{ 'DOOR|Typ pochwytu' | translate }}</b> {{ 'DOOR|Pochwyt zintegrowany' | translate }} </p>
</ng-template>

<ng-template #locksBoxTemplate let-lock="lock">
  <p> <b>{{ 'DOOR|Typ zamka' | translate }}</b> {{ lockBoxSelect.lock.name }} </p>
</ng-template>

<ng-template #hardwareSetBoxTemplate let-hardwareSet="hardwareSet">
  <p> {{ hardwareSetSelect.name }} </p>
  <p> {{ hardwareSetSelect.shortDescription }} </p>
</ng-template>

<ng-template #doorViewerBoxTemplate let-name="name" let-color="color">
  @if (name) {
    <p> <b>{{ 'DOOR|Nazwa wizjera:' | translate }}</b> {{name}}</p>
  }
  @if (color) {
    <p>
      <b>{{ 'DOOR|Kolor:' | translate }}</b> {{color}}
    </p>
  }
</ng-template>
